import React from 'react';
import { Card, Skeleton } from 'antd';
import './SmallCourseCard.less';

const TSmallCourseCardSkeleton: React.FC = () => {
  return (
    <Card
      className="t-skeleton-card-container"
      cover={<Skeleton.Image className="t-skeleton-cover-image" />}
    >
      <Skeleton round active paragraph={{ rows: 2 }} />
    </Card>
  );
};

export default TSmallCourseCardSkeleton;
